module.exports = __webpack_public_path__ + "img/insurance-piggy.69364d3.webp";